window.addEventListener('DOMContentLoaded', () => {
  const searchInput = document.querySelector('.input-block');
  const searchStory = document.querySelector('.input-block__story');
  const searchCross = document.querySelector('.input-block__cross');

  const toggleActiveState = () => {
    searchStory?.classList.toggle('search-active');
    searchCross?.classList.toggle('search-active');
  }

  searchInput?.addEventListener('click', toggleActiveState);
  searchCross?.addEventListener('click', toggleActiveState)
});